import type { ComponentType } from 'react'
import {
  AlertOutlined,
  AuditOutlined,
  FileTextOutlined,
  HistoryOutlined,
  IdcardOutlined,
  InfoCircleOutlined,
  ShareAltOutlined,
  SkinOutlined,
  SolutionOutlined,
  StarOutlined,
  StopOutlined,
  TeamOutlined,
  UserOutlined,
  WarningOutlined,
} from '@ant-design/icons'
import type { PlayerDetailsSectionKey } from '@sportninja/common/features/profile/player/playerDetails'
import { PLAYER_DETAILS_SECTION_ORDER } from '@sportninja/common/features/profile/player/playerDetails/constants/sections'
import { getSectionLabel } from '@sportninja/common/features/profile/player/playerDetails/utils/sectionFields'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import type { ScrollSpyItem } from 'src/components/ScrollSpyLayout'

/** One icon per section, shared by the sidebar and the section title. */
export const PLAYER_DETAILS_SECTION_ICONS: Record<
  PlayerDetailsSectionKey,
  ComponentType
> = {
  contact: UserOutlined,
  emergency: AlertOutlined,
  family: TeamOutlined,
  experience: HistoryOutlined,
  // Same id-card icon as the Edit Player forms' Membership section.
  hockey: IdcardOutlined,
  preferences: StarOutlined,
  additional: InfoCircleOutlined,
  blacklist: StopOutlined,
  notes: FileTextOutlined,
  // Same icon as the Edit Player forms' Social Profiles section.
  social: ShareAltOutlined,
  registrations: SolutionOutlined,
  rosters: SkinOutlined,
  suspensions: WarningOutlined,
  waivers: AuditOutlined,
}

/** Sidebar entries, in section order. */
export const PLAYER_DETAILS_ITEMS: ScrollSpyItem[] =
  PLAYER_DETAILS_SECTION_ORDER.map((key) => ({
    key,
    label: capitalizeWords(getSectionLabel(key)),
    icon: PLAYER_DETAILS_SECTION_ICONS[key],
  }))
